import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { errMsg, useApi } from "@/lib/api";
import { rm } from "@/pages/AkaunPage";

const inp = "w-full h-10 px-3 rounded-lg bg-bg border border-line text-sm focus:outline-none focus:border-[var(--q)]";
const PRODUK = [["payg", "Per Use (RM1.50 / carian)"], ["asas50", "Langganan 50 carian (30 hari)"], ["tanpahad", "Langganan tanpa had (30 hari)"]];

const guess = (sen) => (sen === 2900 ? "asas50" : sen === 4900 ? "tanpahad" : "payg");

export const ResolveDialog = ({ item, onClose, onDone }) => {
  const api = useApi();
  const [q, setQ] = useState(item.email || "");
  const [users, setUsers] = useState(null);
  const [uid, setUid] = useState("");
  const [produk, setProduk] = useState(guess(item.amount_sen));
  const [qty, setQty] = useState(item.amount_sen && item.amount_sen % 150 === 0 ? item.amount_sen / 150 : 1);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => api("get", "/admin/billing/users", null, { params: { q } }).then((u) => { setUsers(u); if (u.length === 1) setUid(u[0].user_id); }).catch(() => setUsers([])), 250);
    return () => clearTimeout(t);
  }, [api, q]);
  const save = async () => {
    setBusy(true);
    try { await api("post", `/admin/billing/unmatched/${item.id}/resolve`, { user_id: uid, produk, qty: Number(qty) }); toast.success("Kuota diaktifkan"); onDone(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="resolve-dialog">
        <DialogHeader><DialogTitle>Aktifkan bayaran {rm(item.amount_sen || 0)}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari e-mel pengguna…" className={inp} data-testid="resolve-search" />
          <select value={uid} onChange={(e) => setUid(e.target.value)} className={inp} data-testid="resolve-user">
            <option value="">{users ? `— Pilih pengguna (${users.length}) —` : "Memuatkan pengguna…"}</option>
            {(users || []).map((u) => <option key={u.user_id} value={u.user_id}>{u.email}</option>)}
          </select>
          <select value={produk} onChange={(e) => setProduk(e.target.value)} className={inp} data-testid="resolve-produk">
            {PRODUK.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          {produk === "payg" && <input type="number" min="1" max="200" value={qty} onChange={(e) => setQty(e.target.value)} className={inp} data-testid="resolve-qty" />}
          <button onClick={save} disabled={busy || !uid || (produk === "payg" && !(qty >= 1 && qty <= 200))} data-testid="resolve-save"
            className="h-10 px-5 rounded-full bg-ink text-bg text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-40">
            {busy && <Loader2 size={14} className="animate-spin" />} Aktifkan kuota
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
